<template>
  <div class="corpo-pagina">

    <!-- MODALE NESSUN CREDITO EMAIL -->
    <div id="noinvioemail" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons red-text text-darken-4 icon-modal-size">error_outline</i>
          {{ translation('modale.invio.mail.titolo.codeeamilcreate.001') }}
        </h4>
        <p>{{ translation('modale.invio.mail.errore.credito') }}</p>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="closeModalError" class="modal-close btn-large">
          {{ translation('btn.annulla') }}
        </a>
      </div>
    </div>

    <!-- MODALE RIEPILOGO INVIO EMAIL -->
    <div id="invioemail" class="modal danger-igotu">
      <div class="modal-content">
        <h4>
          <i class="material-icons text-darken-4 icon-modal-size">security</i>
          {{ translation('modale.riepilogo.invio.001') }}
        </h4>
        <table>
          <tr>
            <td>{{ translation('modale.email.disponibili') }}</td>
            <td>{{ rimanentiIniziali }}</td>
          </tr>
          <tr>
            <td>{{ translation('modale.mail.numero.code') }}</td>
            <td>1</td>
          </tr>
          <tr>
            <td>{{ translation('modale.mail.rimanenti') }}</td>
            <td>{{ rimanentiProvvisori }}</td>
          </tr>
          <tr>
            <td>
              {{ translation('modale.codice.sicurezza') }}<br />
              <h5>{{ codiceSicurezza }}</h5>
            </td>
            <td>
              <div class="input-field">
                <input id="sicurezza" type="text" v-model="codiceSicurezzaDgt" />
                <label for="sicurezza">
                  {{ translation('modale.invio.mail.codice.sicur') }} {{ codiceSicurezza }}
                </label>
              </div>
            </td>
          </tr>
          <tr style="border-bottom: 0 !important;">
            <td colspan="2">
              <span style="color: red;">
                {{ translation('modale.invio.mail.avviso.no.modify') }}
              </span>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <a href="#!" @click="invioMail" :disabled="!isSecurityCodeValid" :class="{ disabled: !isSecurityCodeValid }"
          class="btn-large">
          {{ translation('modale.btn.invia.mail') }}
        </a>
        <a href="#!" @click="closeModal" class="modal-close btn-large">
          {{ translation('btn.annulla') }}
        </a>
      </div>
    </div>

    <!-- TITOLO PAGINA -->
    <div class="row row-text">
      <div class="col s12">
        <h4>
          {{ isNew ? translation('guest.form.addTitle') : translation('guest.form.editTitle') }}
        </h4>
      </div>
    </div>
    <div class="divider"></div>

    <div class="row">

      <!-- FORM ANAGRAFICA -->
      <div class="col s6 card card-radius">
        <form @submit.prevent="submitGuestForm" class="add-margin">

          <div class="row row-titoletto">
            <div class="col s6">
              <h5>{{ translation('pagina.anaqgrafica.pax.001') }}</h5>
            </div>

            <div class="col s6 right-align">
              <!-- Pulsante EDIT (solo se in sola lettura) -->
              <a href="#!" v-red-tooltip="translation('btn.able.modify.pax')" :class="{ nascosto: !formEnabled }" @click="changeDisable" class="btn-small blue">
                <i class="material-icons">edit</i>
              </a>

                <!-- Pulsante SALVA -->
              <button v-red-tooltip="translation('btn.save')" type="submit" :class="{ nascosto: formEnabled }" class="btn ml-2">
                <i class="material-icons">save</i>
              </button>

              <!-- Pulsante ANNULLA modifiche -->
              <button v-red-tooltip="translation('btn.close')" type="button" v-if="!isNew" @click="annulla" :class="{ nascosto: formEnabled }" class="btn ml-2">
               <i class="material-icons">close</i>
              </button>

            </div>
          </div>

          <!-- NOME / COGNOME -->
          <div class="row">
            <div class="input-field col s12 m6">
              <i class="material-icons prefix">person</i>
              <input id="name" type="text" v-model="guest.name" :readonly="formEnabled"
                :class="{ invalid: errors.name }" />
              <label for="name" :class="{ active: !!guest.name }">
                {{ translation('label.name.pax') }}
              </label>
              <span class="helper-text red-text" v-if="errors.name">
                {{ errors.name }}
              </span>
            </div>

            <div class="input-field col s12 m6">
              <i class="material-icons prefix">person_outline</i>
              <input id="surname" type="text" v-model="guest.surname" :readonly="formEnabled"
                :class="{ invalid: errors.surname }" />
              <label for="surname" :class="{ active: !!guest.surname }">
                {{ translation('label.surname.pax') }}
              </label>
              <span class="helper-text red-text" v-if="errors.surname">
                {{ errors.surname }}
              </span>
            </div>
          </div>

          <!-- EMAIL / ACCOMPAGNATORI -->
          <div class="row">
            <div class="input-field col s12 m6">
              <i class="material-icons prefix">send</i>
              <input id="email" type="email" v-model="guest.email" :readonly="formEnabled"
                :class="{ invalid: errors.email }" />
              <label for="email" :class="{ active: !!guest.email }">
                {{ translation('label.email.pax') }}
              </label>
              <span class="helper-text red-text" v-if="errors.email">
                {{ errors.email }}
              </span>
            </div>

            <div class="input-field col s12 m6">
              <i class="material-icons prefix">group</i>
              <input id="accompanyingPersons" type="number" min="0" v-model.number="guest.accompanying_persons"
                :readonly="formEnabled" :class="{ invalid: errors.accompanying_persons }" />
              <label for="accompanyingPersons" :class="{
                active:
                  guest.accompanying_persons !== null &&
                  guest.accompanying_persons !== undefined &&
                  guest.accompanying_persons !== 0
              }">
                {{ translation('accompanying.persons.number') }}
              </label>
              <span class="helper-text red-text" v-if="errors.accompanying_persons">
                {{ errors.accompanying_persons }}
              </span>
            </div>
          </div>

          <!-- NOTE -->
  <div class="input-field col s12">
  <i class="material-icons prefix">notes</i>

  <textarea
    id="notes"
    class="materialize-textarea"
    v-model="guest.notes"
    :readonly="formEnabled"
    maxlength="200"
    @input="updateNotesCount"
    :class="{
      invalid: errors.notes,
      'warning-limit': notesCount >= 180 && notesCount < 200
    }"
  ></textarea>

  <label for="notes" :class="{ active: !!guest.notes }">
    {{ translation('note.field.xls') }}
  </label>

  <!-- Contatore -->
  <div
    class="notes-counter"
    :class="{
      'counter-warning': notesCount >= 180 && notesCount < 200,
      'counter-error': notesCount >= 200
    }"
  >
    {{ notesCount }} / 200
  </div>

  <span class="helper-text red-text" v-if="errors.notes">
    {{ errors.notes }}
  </span>
</div>

          <!-- CAMPI CUSTOM -->
          <div class="row" v-for="(labelName, index) in customFieldLabels" :key="index">
            <div class="input-field col s12">
              <i class="material-icons prefix">info_outline</i>
              <input :id="'custom_field_' + index" type="text" v-model="guest.attributes[labelName]"
                :readonly="formEnabled" />
              <label :for="'custom_field_' + index" :class="{
                active:
                  guest.attributes &&
                  guest.attributes[labelName]
              }">
                {{ labelName }}
              </label>
            </div>
          </div>

        </form>
      </div>

      <!-- SPAZIO -->
      <div class="col s1"></div>

      <!-- COLONNA DESTRA: TRANSITI + EMAIL -->
      <div class="col s5">

        <!-- TRANSITI -->
        <div class="row">
          <div v-if="guest && guest.transits" class="col s12 card card-radius">
            <div class="add-margin">
              <div class="row row-titoletto">
                <div class="col s12">
                  <h5>
                    {{ translation('pagina.transiti.titolo') || 'Transiti' }}
                    <span v-if="guest.transits.length">
                      ({{ guest.transits.length }})
                    </span>
                  </h5>
                </div>
              </div>

              <div v-if="guest.transits.length === 0" class="no-mails">
                {{ translation('pagina.transiti.vuoti') || 'Nessun transito registrato' }}
              </div>

              <table v-else class="striped responsive-table transits-table">
                <thead>
                  <tr>
                    <th>{{ translation('pagina.transiti.data') || 'Data Transito' }}</th>
                    <!--th>{{ translation('pagina.transiti.sessione') || 'Sessione' }}</th>
                    <th>{{ translation('pagina.transiti.tipo') || 'Tipo Sessione' }}</th -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(t, index) in formattedTransits" :key="index">
                    <td>{{ t.date }}</td>
                    <!--td>{{ t.sessionId }}</td>
                    <td>{{ t.sessionType }}</td -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- EMAIL INVIATE -->
        <div class="row" v-if="hasMail">
          <div v-if="hasMail" class="col s12 card card-radius">
            <div class="add-margin">
              <div class="row row-titoletto">
                <div class="col s8">
                  <h5>
                    {{ translation('pagina.anaqgrafica.pax.002') }}
                    ({{ formattedSendedMails.length }})
                  </h5>
                </div>
                <div class="col s4">
                  <a v-red-tooltip="translation('btn.able.email.pax') + ' ' +guest.surname" href="javascript:void(0)" class="btn-small img-button-delete" @click="checkTest">
                    <i class="material-icons">send</i>
                  </a>
                </div>
              </div>

              <div class="mails-container">
                <div v-if="formattedSendedMails.length === 0" class="no-mails">
                  {{ translation('pagina.anaqgrafica.pax.003') }}
                </div>

                <table v-else class="striped responsive-table">
                  <thead>
                    <tr>
                      <th>{{ translation('pagina.mail.titolo.tabella.001') }}</th>
                      <th>{{ translation('pagina.mail.titolo.tabella.002') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mail, index) in formattedSendedMails" :key="index">
                      <td>{{ mail.date }}</td>
                      <td class="status-cell">
                        <i class="material-icons tiny-stat-icon" :class="mail.statusClass">
                          {{ mail.icon }}
                        </i>
                        <span :class="mail.statusClass">
                          {{ mail.label }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'
import eventSetting from '@/store/eventSettings.js'
import apiService from '@/services/apiService.js'
import M from 'materialize-css'
import { guestModel } from '@/models/guestModel.js'
import toast from '@/services/toast.js'
import useAuthStore from '@/store/authStore.js'

export default {
  name: 'FormPax',
  props: {
    isNew: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toast,
      guest: {
        ...JSON.parse(JSON.stringify(guestModel)),
        attributes: {},
        sended_mails: [],
        transits: []
      },
      formEnabled: true, // per edit: true (sola lettura) - per new: viene messo a false in mounted
      modal: null,
      modalerror: null,
      codiceSicurezza: null,
      codiceSicurezzaDgt: null,
      rimanentiProvvisori: 0,
      rimanentiIniziali: 0,
      totaleEmail: 0,
      notesCount: 0,
      errors: {
        name: null,
        surname: null,
        email: null,
        accompanying_persons: null,
        notes: null // <--- AGGIUNTO
      }
    }
  },
  computed: {

    formattedTransits () {
      if (!this.guest || !Array.isArray(this.guest.transits)) return []

      return this.guest.transits.map(t => {
        const date = t.date_transits || t.date_transit || '—'

        const accomp =
      t.accompaning_id && Number(t.accompaning_id) !== 0
        ? ` (Accompagnatore ${t.accompaning_id})`
        : ''

        const sessionId =
      t.session_id &&
      (t.session_id.uid || t.session_id.session_id)
        ? (t.session_id.uid || `ID ${t.session_id.session_id}`)
        : '—'

        const sessionType =
      t.session_id?.type_session_id?.name ||
      (t.session_id?.type_session_id
        ? `#${t.session_id.type_session_id}`
        : '—')

        return {
          date: date + accomp,
          sessionId,
          sessionType
        }
      })
    },

    // FUNZIONE TRADUZIONE USATA NEL TEMPLATE: {{ translation('chiave') }}
    translation () {
      if (translationStore && translationStore.getters) {
        return translationStore.getters.traduzione
      }
      return (key) => `[${key}]`
    },

    fullEventData () {
      if (eventSetting && eventSetting.getters) {
        return eventSetting.getters.eventModel || {}
      }
      return {}
    },

    userUid () {
      return (useAuthStore && useAuthStore.getters)
        ? (useAuthStore.getters.uid || null)
        : null
    },

    hasMail () {
      return this.fullEventData.has_mailer || false
    },

    eventLabels () {
      return this.fullEventData.event_labels || []
    },

    customFieldLabels () {
      const labels = []
      if (Array.isArray(this.eventLabels)) {
        this.eventLabels.forEach(label => {
          if (label.name) {
            labels.push(label.name)
          }
        })
      }
      return labels
    },

    isSecurityCodeValid () {
      return this.codiceSicurezza &&
        this.codiceSicurezzaDgt === this.codiceSicurezza
    },

    checkBalanceEmail () {
      const guestSend = 1
      const remainEmails =
        useAuthStore &&
          useAuthStore.getters &&
          useAuthStore.getters.balance &&
          useAuthStore.getters.balance.remaining
          ? useAuthStore.getters.balance.remaining.emails
          : 0

      return guestSend <= remainEmails
    },

    formattedSendedMails () {
      const sendedMails = this.guest.sended_mails || []

      const sorted = [...sendedMails].sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })

      return sorted.map(mailItem => {
        const rawStatus = mailItem.logMail?.status || 'IN ATTESA'
        return {
          date: this.formatMailDate(mailItem.createdAt),
          rawStatus,
          statusClass: this.getMailStatusClass(rawStatus),
          icon: this.getMailStatusIcon(rawStatus),
          label: this.getMailStatusLabel(rawStatus)
        }
      })
    }
  },
  watch: {
    'fullEventData.uid': {
      handler (newUid) {
        if (newUid) {
          this.prepareGuestData()
        }
      },
      immediate: true
    },
    eventLabels: {
      handler (newLabels) {
        if (this.fullEventData.uid && newLabels && newLabels.length > 0) {
          this.prepareGuestData()
        }
      }
    }
  },
  methods: {
    /* parseDateSafe (raw) {
      d.toLocaleString()
    }, */

    updateNotesCount () {
      // Blocchiamo fisicamente l’input oltre 200 (in aggiunta al maxlength)
      if (this.guest.notes.length > 200) {
        this.guest.notes = this.guest.notes.substring(0, 200)
      }
      this.notesCount = this.guest.notes.length
    },

    // Helper per traduzioni in JS
    t (key) {
      return translationStore.getters.traduzione
        ? translationStore.getters.traduzione(key)
        : key
    },

    // MODALI
    async openModal () {
      if (this.modal) this.modal.open()
    },

    closeModal () {
      if (this.modal) this.modal.close()
    },

    async openModalError () {
      if (this.modalerror) this.modalerror.open()
    },

    closeModalError () {
      if (this.modalerror) this.modalerror.close()
    },

    // BILANCIO EMAIL
    async fetchBalanceAndUpdateStore () {
      loadingStore.commit('setLoading', true)
      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return false
        }

        const uid = this.userUid
        if (!uid) {
          return false
        }

        const url = process.env.VUE_APP_URL_EVENTS + '/checkins/get-balance/' + uid
        const balanceRaw = await apiService.sendRequestWithBearer('GET', url, token, null, null)

        let balance = balanceRaw
        if (typeof balanceRaw === 'string') {
          try {
            balance = JSON.parse(balanceRaw)
          } catch (e) {
            return false
          }
        }

        await useAuthStore.dispatch('newBalance', balance)
        return true
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    async checkTest () {
      await this.fetchBalanceAndUpdateStore()

      this.codiceSicurezza = null
      this.codiceSicurezzaDgt = null

      if (!this.checkBalanceEmail) {
        this.openModalError()
        return
      }

      this.rimanentiIniziali =
        useAuthStore &&
          useAuthStore.getters &&
          useAuthStore.getters.balance &&
          useAuthStore.getters.balance.remaining
          ? useAuthStore.getters.balance.remaining.emails
          : 0

      this.rimanentiProvvisori = this.rimanentiIniziali - 1
      this.codiceSicurezza = this.generateFiveDigitString()
      this.codiceSicurezzaDgt = null

      this.openModal()
    },

    generateFiveDigitString () {
      const randomNum = Math.floor(Math.random() * 90000) + 10000
      return String(randomNum)
    },

    invioMail () {
      if (!this.isSecurityCodeValid) return
      this.closeModal()
      this.createCodeMails()
    },

    async createCodeMails () {
      loadingStore.commit('setLoading', true)

      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return
        }

        const uid = this.fullEventData.uid
        const url = process.env.VUE_APP_URL_EVENTS + '/code-mail/create-user'

        const payload = {
          event_id: uid,
          guest: { ...this.guest }
        }

        const jsonEvents = await apiService.sendRequestWithBearer('POST', url, token, payload)

        if (jsonEvents.message && jsonEvents.message === 'ok') {
          const currentMails = Array.isArray(this.guest.sended_mails)
            ? this.guest.sended_mails
            : []

          if (jsonEvents.sended_mails) {
            const updatedMails = [...currentMails, jsonEvents.sended_mails]
            this.$set(this.guest, 'sended_mails', updatedMails)
          }

          eventSetting.dispatch('addGuestToEvent', this.guest)

          this.toast.createStampToast(
            'thumb_up',
            this.translation('pagina.anaqgrafica.tost.invio.pax.001'),
            'toast-green'
          )
        } else {
          this.toast.createStampToast(
            'error_outline',
            this.translation('pagina.anaqgrafica.tost.invio.pax.002'),
            'red'
          )
        }
      } catch (error) {
        this.toast.createStampToast(
          'error_outline',
          this.translation('error.network'),
          'red'
        )
        this.$router.push('/error')
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    formatMailDate (isoDate) {
      if (!isoDate) return 'N/D'
      return new Date(isoDate).toLocaleString()
    },

    getMailStatusClass (status) {
      const s = status ? status.toUpperCase() : ''
      if (s === 'SUCCESS') {
        return 'green-text text-darken-2'
      }
      if (['FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(s)) {
        return 'red-text text-darken-2'
      }
      return 'grey-text text-darken-1'
    },

    getMailStatusLabel (status) {
      const s = status ? status.toUpperCase() : ''
      if (s === 'SUCCESS') {
        return this.translation('pagina.lista.email.statistiche.003')
      }
      if (['FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(s)) {
        return this.translation('pagina.lista.email.statistiche.004')
      }
      return this.translation('pagina.lista.email.statistiche.005')
    },

    getMailStatusIcon (status) {
      const s = status ? status.toUpperCase() : ''
      if (s === 'SUCCESS') return 'check_circle'
      if (['FAIL', 'ERROR', 'DENY', 'BOUNCE'].includes(s)) return 'cancel'
      return 'schedule'
    },

    // TOGGLE EDIT
    changeDisable () {
      this.formEnabled = !this.formEnabled
      this.$nextTick(() => {
        M.updateTextFields()
      })
    },

    annulla () {
      this.prepareGuestData()
      this.formEnabled = !this.isNew // torna allo stato originale
      this.$nextTick(() => {
        M.updateTextFields()
      })
    },

    async prepareGuestData () {
      loadingStore.commit('setLoading', true)
      try {
        let guestToSet

        if (this.isNew) {
          guestToSet = {
            ...JSON.parse(JSON.stringify(guestModel)),
            attributes: {},
            sended_mails: [],
            transits: []
          }
        } else {
          const foundGuest = eventSetting.getters.guest
          if (foundGuest && foundGuest.uid) {
            guestToSet = { ...foundGuest }

            if (!guestToSet.attributes) {
              this.$set(guestToSet, 'attributes', {})
            }
            if (!guestToSet.sended_mails) {
              this.$set(guestToSet, 'sended_mails', [])
            }
            if (!guestToSet.transits) {
              this.$set(guestToSet, 'transits', [])
            }
          } else {
            this.toast.createStampToast(
              'error_outline',
              this.translation('guest.form.noGuestToEdit'),
              'orange'
            )
            this.$router.push('/list-guests')
            return
          }
        }

        this.initializeCustomFieldsInAttributes(guestToSet)
        this.guest = guestToSet

        this.notesCount = this.guest.notes ? this.guest.notes.length : 0

        this.$nextTick(() => {
          M.updateTextFields()
        })
      } catch (error) {
        this.toast.createStampToast(
          'error_outline',
          this.translation('guest.form.loadError'),
          'red'
        )
        this.$router.push('/list-guests')
      } finally {
        loadingStore.commit('setLoading', false)
      }
    },

    initializeCustomFieldsInAttributes (targetGuest) {
      if (!targetGuest.attributes) {
        this.$set(targetGuest, 'attributes', {})
      }
      this.customFieldLabels.forEach(labelName => {
        if (!Object.prototype.hasOwnProperty.call(targetGuest.attributes, labelName)) {
          this.$set(targetGuest.attributes, labelName, '')
        }
      })
    },

    transformGuestForApi (formData) {
      const apiData = { ...formData }

      if (!apiData.attributes) {
        apiData.attributes = {}
      }

      for (let i = 0; i <= 35; i++) {
        const fieldKey = `field${i}`
        if (Object.prototype.hasOwnProperty.call(apiData, fieldKey)) {
          delete apiData[fieldKey]
        }
      }

      delete apiData.sended_mails
      delete apiData.transits

      return {
        guest: apiData,
        event_id: eventSetting.getters.uidEvent
      }
    },

    validateForm () {
      // reset errori
      this.errors = {
        name: null,
        surname: null,
        email: null,
        accompanying_persons: null
      }

      let isValid = true

      if (!this.guest.name || this.guest.name.trim() === '') {
        this.errors.name = this.t('filed.required.validation')
        isValid = false
      }

      if (!this.guest.surname || this.guest.surname.trim() === '') {
        this.errors.surname = this.t('filed.required.validation')
        isValid = false
      }

      // logica email: obbligatoria se hasMail, altrimenti solo se presente controllo formato
      if (this.hasMail) {
        if (!this.guest.email || this.guest.email.trim() === '') {
          this.errors.email = this.t('filed.required.validation')
          isValid = false
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.guest.email)) {
          this.errors.email = this.t('filed.email.validation')
          isValid = false
        }
      } else {
        if (this.guest.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.guest.email)) {
          this.errors.email = this.t('filed.email.validation')
          isValid = false
        }
      }

      if (
        this.guest.accompanying_persons === null ||
        this.guest.accompanying_persons === undefined ||
        isNaN(this.guest.accompanying_persons) ||
        this.guest.accompanying_persons < 0
      ) {
        this.errors.accompanying_persons = this.t('validation.accompanyingPersonsInvalid')
        isValid = false
      }

      if (this.guest.notes && this.guest.notes.length > 200) {
        this.errors.notes = this.t('note.max.charter.errore') // usa la tua traduzione
        isValid = false
      }

      this.$nextTick(() => {
        M.updateTextFields()
      })
      return isValid
    },

    async submitGuestForm () {
      loadingStore.commit('setLoading', true)

      if (!this.validateForm()) {
        loadingStore.commit('setLoading', false)
        return
      }

      try {
        const token = await apiService.getClientCredentialsToken()
        if (!token) {
          this.$router.push('/error')
          return
        }

        const guestDataForApi = this.transformGuestForApi(this.guest)

        const url = process.env.VUE_APP_URL_EVENTS + '/guests'
        let method = 'POST'

        let msg = this.translation('pagina.anaqgrafica.salvataggio.ok')

        if (!this.isNew) {
          msg = this.translation('pagina.anaqgrafica.salvataggio.modifica.ok')
          if (!this.guest.uid) {
            loadingStore.commit('setLoading', false)
            this.$router.push('/error')
            return
          }
          method = 'PUT'
        }

        const response = await apiService.sendRequestWithBearer(
          method,
          url,
          token,
          guestDataForApi
        )

        if (response) {
          if (!this.isNew) {
            eventSetting.dispatch('deleteGuestFromEvent', this.guest.uid, false)
          }

          eventSetting.dispatch('addGuestToEvent', response)

          this.toast.createStampToast('thumb_up', msg, 'toast-green')

          this.$router.push('/list-guests')
        } else {
          this.toast.createStampToast(
            'error_outline',
            this.translation('guest.form.apiError'),
            'red'
          )
        }
      } catch (error) {
        this.toast.createStampToast(
          'error_outline',
          this.translation('error.network'),
          'red'
        )
        this.$router.push('/error')
      } finally {
        loadingStore.commit('setLoading', false)
      }
    }
  },
  mounted () {
    // per i nuovi ospiti: form modificabile da subito
    // per edit: form in sola lettura finché non si clicca "edit"
    this.formEnabled = !this.isNew

    const elems = document.getElementById('invioemail')
    const noinvio = document.getElementById('noinvioemail')

    if (elems) {
      this.modal = M.Modal.init(elems, {
        onCloseEnd: () => { },
        onOpenEnd: () => {
          loadingStore.commit('setLoading', false)
        }
      })
    }

    if (noinvio) {
      this.modalerror = M.Modal.init(noinvio, {
        onCloseEnd: () => { },
        onOpenEnd: () => {
          loadingStore.commit('setLoading', false)
        }
      })
    }

    this.$nextTick(() => {
      M.updateTextFields()
    })
  },
  beforeDestroy () {
    loadingStore.commit('setLoading', false)
  }
}
</script>

<style scoped>
.corpo-pagina {
  padding: 20px;
}

.ml-2 {
  margin-left: 0.5rem;
}

/* Contatore base */
.notes-counter {
  font-size: 0.8rem;
  margin-top: -5px;
  margin-bottom: 5px;
  text-align: right;
  color: #666;
}

/* Contatore giallo quando >180 */
.counter-warning {
  color: #FF9800 !important; /* amber */
  font-weight: bold;
}

/* Contatore rosso (teoricamente non arriverai a 200) */
.counter-error {
  color: #F44336 !important;
  font-weight: bold;
}

/* Evidenzia la textarea quando >180 */
.warning-limit {
  border-bottom: 1px solid #FF9800 !important;
  box-shadow: 0 1px 0 0 #FF9800 !important;
}

/* -------------------------------------- */
/* Stili per Email Inviate */
/* -------------------------------------- */
.mails-container {
  max-height: 400px;
  overflow-y: auto;
  padding-top: 5px;
}

.no-mails {
  text-align: center;
  font-style: italic;
  color: #9e9e9e;
  padding: 20px 0;
}

.status-cell {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.tiny-stat-icon {
  font-size: 16px;
  margin-right: 6px;
  line-height: 1;
}

.green-text.text-darken-2 {
  color: #4caf50 !important;
}

.red-text.text-darken-2 {
  color: #f44336 !important;
}

.grey-text.text-darken-1 {
  color: #9e9e9e !important;
}

/* -------------------------------------- */
/* Errori Materialize */
input.invalid {
  border-bottom: 1px solid #F44336 !important;
  box-shadow: 0 1px 0 0 #F44336 !important;
}

input.invalid+label:after {
  color: #F44336 !important;
}

textarea.materialize-textarea.invalid {
  border-bottom: 1px solid #F44336 !important;
  box-shadow: 0 1px 0 0 #F44336 !important;
}

textarea.materialize-textarea.invalid+label:after {
  color: #F44336 !important;
}

.helper-text {
  font-size: 0.8rem;
  margin-top: 5px;
}

.add-margin {
  margin: 3%;
}

.nascosto {
  display: none;
}
</style>
